import React from 'react';
import { Field, TextInput } from '../lib/FormControls';

export default function Step3Financial({ form, setField }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Financial Information</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Annual Income" required>
          <TextInput
            value={form.annual_income}
            onChange={(e) => setField('annual_income', e.target.value)}
          />
        </Field>
        <Field label="Household Income" required>
          <TextInput
            value={form.household_income}
            onChange={(e) => setField('household_income', e.target.value)}
          />
        </Field>
        <Field label="Monthly Expenses">
          <TextInput
            value={form.monthly_expenses}
            onChange={(e) => setField('monthly_expenses', e.target.value)}
          />
        </Field>
        <Field label="Net Worth">
          <TextInput value={form.net_worth} onChange={(e) => setField('net_worth', e.target.value)} />
        </Field>
      </div>
    </div>
  );
}
